export default "__VITE_ASSET__CvU$1UrE__"